import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import generalActions from 'redux/actions/generalActions'
import drawItActions from 'redux/actions/drawItActions'

const CONFIRM_TYPE = confirmTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR

const DrawItUploadReferenceMediaErrorConfirm = props => (
	<Confirm
		btOne={'No'}
		btTwo={'Yes'}
		alertMessage={props.message}
		actionButtonType={0}
		actionOne={() => props.actions.closeConfirm(CONFIRM_TYPE)}
		actionTwo={
			() => {
				props.actions.requireUploadConfirmation()
				props.actions.closeConfirm(CONFIRM_TYPE)
			}
		}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
		requireUploadConfirmation: drawItActions.requireUploadConfirmation,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(DrawItUploadReferenceMediaErrorConfirm)

export { DrawItUploadReferenceMediaErrorConfirm }
